export default __webpack_public_path__ + "static/media/already_verified.c0a60194.png";